import { FC, useState, useRef } from 'react'
import { useTranslation } from "react-i18next";
import css from './index.module.less';
import { Button, Form, Input, Toast } from 'antd-mobile'
import { rules } from '@/pages/user/Register/const'
import { securityVliadCode, noteregister } from '@/api/register'

export const Register = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false)

    const onFinish = async (values) => {
        const { phone, code } = values

        setSubmitting(true)
        const { data } = await noteregister({
            phone,
            validatecode: code,
        })
        setSubmitting(false)
        if (data.status !== 200) {
            return Toast.show(data.errorMsg)
        }
        Toast.show(`${t('user-center.register.register-suc')}`)
        setTimeout(() => {
            window.location.href = '/'
        }, 2000)
    }

    return <>
        <div className={css.Page}>
            <Form form={form} className={css.Form} onFinish={onFinish}>
                <div className={css.PageHd}>
                    <AccountFormItems />
                </div>

                <div className={css.BtnSubmitWrap}>
                    <Button className={css.BtnSubmit} block type='submit' color='primary' size='large' loading={submitting}>{t('user-center.register.register-btn')}</Button>
                </div>
                <div className={css.registerTip}>{t('user-center.register.register-tips')}<a target='__blank' href="/registProtocol.html">{t('user-center.register.protocol')}</a></div>
            </Form>
        </div>
    </>
}

// 账号登录表单项
let codeLimitTime = 89
const AccountFormItems: FC = () => {
    const { t } = useTranslation();
    const [codeText, setCodeText] = useState(`${t('user-center.register.code-text')}`)
    const [value, setValue] = useState('')
    const intervalRef: any = useRef()

    const onVCodePress = async () => {
        if (!value) {
            return Toast.show(`${t('user-center.register.in-phone')}`)
        }
        if (intervalRef.current && codeLimitTime > 0 && codeLimitTime < 89) return

        const { data } = await securityVliadCode({
            type: 5,
            phonenum: value,
        })

        if (data.status !== 200) {
            return Toast.show(data.errorMsg)
        }

        Toast.show(`${t('user-center.register.send-code-done')}`)

        intervalRef.current = setInterval(() => {
            if (codeLimitTime > 0) {
                setCodeText(`${t('user-center.register.send-again')}(${codeLimitTime})`)
                codeLimitTime--
            } else {
                clearInterval(intervalRef.current)
                setCodeText(`${t('user-center.register.code-text')}`)
                codeLimitTime = 89
            }
        }, 1000)
    }

    return (
        <>
            <Form.Item className={css.InputWrap} name='phone' rules={rules.phone}>
                <Input
                    className={css.Input}
                    placeholder={t('user-center.register.in-phone')}
                    clearable
                    onChange={val => {
                        setValue(val)
                    }}
                />
            </Form.Item>
            <Form.Item
                className={css.InputWrap}
                name='code'
                rules={rules.code}
                extra={
                    <div className={css.extraPart} onClick={onVCodePress}>
                        <a>{codeText}</a>
                    </div>
                }
            >
                <Input className={css.Input} placeholder={t('user-center.register.in-code')} clearable />
            </Form.Item>
        </>
    )
}